<stock-sub-menu></stock-sub-menu>
<div>
  <h2 class="h2_header">Stock Locations</h2>
  <div fxLayout="row">
    <li *ngFor="let ship of shipmentList">
      <h2 class="stock_header">Shipment {{ship.shipment_id}}</h2>
      <div class="stock_size">Size: {{ship.shipment_size}}</div>
      <div fxLayout="column">
    <li *ngFor="let location of locationSummary">
      <ng-container *ngIf="ship.shipment_id == location.shipment_number">
        <div class="stock_div">{{location.name}}: {{location.unit_count}}</div>
      </ng-container>
    </li>
  </div>
  <div class="stock_total">Total: {{calTotalLoc(ship.shipment_id)}}</div>
  </li>
</div>
<br>
<br>
<h2 class="h2_header">Office Status</h2>
<div fxLayout="row">
  <li *ngFor="let ship of shipmentList">
    <h2 class="stock_header">Shipment {{ship.shipment_id}}</h2>
    <div fxLayout="column">
  <li *ngFor="let office of officeSummary">
    <ng-container *ngIf="ship.shipment_id == office.shipment_number">
      <div class="stock_div">{{office. stock_office_status_details}}: {{office.unit_count}}</div>
    </ng-container>
  </li>
</div>
<div class="stock_total">Total: {{calTotalOffice(ship.shipment_id)}}</div>
</li>
</div>
<br>
<br>
<h2 class="h2_header">Installers</h2>
<div fxLayout="column">
  <li *ngFor="let company of companyList">
    <h2 class="h2_title">{{company.installer_company_name}}</h2>
    <div fxLayout="row">
      <li *ngFor="let ship of shipmentList">
        <h2 class="stock_header">Shipment {{ship.shipment_id}}</h2>
        <div fxLayout="column">
          <li *ngFor="let installer of installerSummary">
            <ng-container
            *ngIf="(ship.shipment_id==installer.installed_shipment_number) && (installer.installed_company_id==company.installer_company_id || installer.available_company_id==company.installer_company_id)">
              <div class="stock_installer_top">{{noNulls(installer.available_installer_name, installer.installed_installer_name)}}</div>
              <div class="stock_installer_bottom">Available: {{checkZero(installer.available_unit_count)}} Installed:
                {{checkZero(installer.installed_unit_count)}}</div>
            </ng-container>
          </li>
        </div>
        <div class="stock_total" [innerText]="calTotalCompany(ship.shipment_id, company.installer_company_id)"></div>
      </li>
    </div>
    <br>
    <br>
  </li>
</div>
